var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHome = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15.807 6.656 8.557.2C8.26-.067 7.74-.067 7.441.2L.194 6.656C-.24 7.044.104 7.66.752 7.66h1.253a.7.7 0 0 0-.023.17v7.37c0 .443.423.8.95.8h1.9c.36 0 .652-.248.652-.55v-4.757c0-.275.266-.498.59-.498h3.844c.328 0 .59.223.59.498v4.757c0 .303.293.55.652.55h1.902c.523 0 .949-.357.949-.8V7.83a.7.7 0 0 0-.023-.17h1.253c.657 0 .999-.616.566-1.004"
})));
export default SvgHome;